export default class ViewAdminAccountController {
    // @ngInject
    constructor(targetUser, group) {
        this.targetUser = targetUser;
        this.group = group;

        this.label = _.startCase(`${this.group.type} administrator`);
    }
}
